<li class="wrp" (mouseenter)="toggleShowDiv()" (mouseleave)="toggleHidDiv()">
    <a multilang class="w100" [href]="menu?.link">{{menu?.title}}</a>
    <ng-container *ngIf="menu.column?.length > 0">
        <ul class="menubody mat-elevation-z1" [@slideInOut]="isBrowser ? animationState : ''">
            <li class="columnwrp">
                <ng-container *ngFor="let cl of menu.column;let k=index;">
                    <clever-menu2-subitem [column]="cl" [deskmode]="deskmode"></clever-menu2-subitem>
                </ng-container>
            </li>
        </ul>
    </ng-container>
</li>